import { render, staticRenderFns } from "./EditarRede.vue?vue&type=template&id=65b000ce&"
import script from "./EditarRede.vue?vue&type=script&lang=js&"
export * from "./EditarRede.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports